import { render, staticRenderFns } from "./typeStatistic.vue?vue&type=template&id=4085658b&scoped=true&"
import script from "./typeStatistic.vue?vue&type=script&lang=js&"
export * from "./typeStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4085658b",
  null
  
)

export default component.exports